import { createSlice } from '@reduxjs/toolkit';
import { fetchAllUsers, fetchSystemSettings, updateUserPayment, updateSystemSetting, fetchUserProfiles, fetchAuspiciousRequests, toggleUserVisibility, fetchUserChats, fetchChatMessages } from './adminAction';

const initialState = {
    users: [],
    settings: {},
    userProfiles: [],
    auspiciousRequests: [],
    loading: false,
    settingsLoading: false,
    profilesLoading: false,
    requestsLoading: false,
    error: null,
    success: false,
    selectedUserChats: [],
    selectedChatMessages: [],
    chatsLoading: false,
    messagesLoading: false,
    pagination: {
        page: 1,
        limit: 10,
        total: 0,
        totalPages: 0
    }
};

const adminSlice = createSlice({
    name: 'admin',
    initialState,
    reducers: {
        clearAdminState: (state) => {
            state.users = [];
            state.settings = {};
            state.error = null;
            state.success = false;
        }
    },
    extraReducers: (builder) => {
        builder
            // Fetch Users
            .addCase(fetchAllUsers.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllUsers.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.users = payload.users;
                state.pagination = payload.pagination;
            })
            .addCase(fetchAllUsers.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = payload;
            })
            // Fetch Settings
            .addCase(fetchSystemSettings.pending, (state) => {
                state.settingsLoading = true;
            })
            .addCase(fetchSystemSettings.fulfilled, (state, { payload }) => {
                state.settingsLoading = false;
                state.settings = payload;
            })
            .addCase(fetchSystemSettings.rejected, (state, { payload }) => {
                state.settingsLoading = false;
                state.error = payload;
            })
            // Update Payment
            .addCase(updateUserPayment.fulfilled, (state, { payload }) => {
                state.users = state.users.map(user =>
                    user.id === payload.userId
                        ? { ...user, user_permission: payload.isPaid ? 1 : 0 }
                        : user
                );
            })
            // Update Setting
            .addCase(updateSystemSetting.fulfilled, (state, { payload }) => {
                state.settings[payload.key] = payload.value;
            })
            // Fetch User Profiles
            .addCase(fetchUserProfiles.pending, (state) => {
                state.profilesLoading = true;
                state.error = null;
            })
            .addCase(fetchUserProfiles.fulfilled, (state, { payload }) => {
                state.profilesLoading = false;
                state.userProfiles = payload;
            })
            .addCase(fetchUserProfiles.rejected, (state, { payload }) => {
                state.profilesLoading = false;
                state.error = payload;
            })
            // Fetch Auspicious Requests
            .addCase(fetchAuspiciousRequests.pending, (state) => {
                state.requestsLoading = true;
                state.error = null;
            })
            .addCase(fetchAuspiciousRequests.fulfilled, (state, { payload }) => {
                state.requestsLoading = false;
                state.auspiciousRequests = payload;
            })
            .addCase(fetchAuspiciousRequests.rejected, (state, { payload }) => {
                state.requestsLoading = false;
                state.error = payload;
            })
            // Toggle User Visibility
            .addCase(toggleUserVisibility.fulfilled, (state, { payload }) => {
                state.users = state.users.map(user =>
                    user.id === payload.userId
                        ? { ...user, is_hidden: payload.isHidden ? 1 : 0 }
                        : user
                );
            })
            // Fetch User Chats
            .addCase(fetchUserChats.pending, (state) => {
                state.chatsLoading = true;
            })
            .addCase(fetchUserChats.fulfilled, (state, { payload }) => {
                state.chatsLoading = false;
                state.selectedUserChats = payload;
            })
            .addCase(fetchUserChats.rejected, (state, { payload }) => {
                state.chatsLoading = false;
                state.error = payload;
            })
            // Fetch Chat Messages
            .addCase(fetchChatMessages.pending, (state) => {
                state.messagesLoading = true;
            })
            .addCase(fetchChatMessages.fulfilled, (state, { payload }) => {
                state.messagesLoading = false;
                state.selectedChatMessages = payload;
            })
            .addCase(fetchChatMessages.rejected, (state, { payload }) => {
                state.messagesLoading = false;
                state.error = payload;
            });
    }
});

export const { clearAdminState } = adminSlice.actions;
export default adminSlice.reducer;
